"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledListItemText = exports.StyledListItemButton = exports.StyledList = exports.StyledDivider = exports.Root = exports.Header = exports.Content = exports.ClearIcon = void 0;
var _isPropValid = _interopRequireDefault(require("@emotion/is-prop-valid"));
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)(_mui.Modal)(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    alignItems: 'end'
  }
}));
const Content = exports.Content = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: _mui.SHADOW_LEVEL2,
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '472px',
  padding: theme.spacing(2),
  width: '472px',
  zIndex: 1,
  '&:focus-visible': {
    outline: 'none'
  },
  [theme.breakpoints.down('sm')]: {
    borderBottomLeftRadius: '0px',
    borderBottomRightRadius: '0px',
    maxWidth: 'unset',
    width: '100%'
  }
}));
const Header = exports.Header = (0, _mui.styled)('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%'
});
const ClearIcon = exports.ClearIcon = (0, _mui.styled)(_icons.Clear)(({
  theme
}) => ({
  color: theme.palette.grey[700],
  cursor: 'pointer',
  height: '26px',
  width: '26px'
}));
const StyledList = exports.StyledList = (0, _mui.styled)(_mui.List)({
  paddingBottom: '0px',
  width: 'calc(100% - 20px)'
});
const StyledListItemText = exports.StyledListItemText = (0, _mui.styled)(_mui.ListItemText)(({
  theme
}) => ({
  color: theme.palette.grey[900],
  letterSpacing: '-0.2px',
  ...theme.typography.button,
  textTransform: 'none'
}));
const StyledListItemButton = exports.StyledListItemButton = (0, _mui.styled)(_mui.ListItemButton)(({
  theme
}) => ({
  height: '70px',
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2)
}));
const StyledDivider = exports.StyledDivider = (0, _mui.styled)(_mui.Divider, {
  shouldForwardProp: propName => (0, _isPropValid.default)(propName)
})(({
  isItemHovered,
  theme
}) => ({
  border: `1px solid ${theme.palette.grey[100]}`,
  height: '0px',
  ...(isItemHovered ? null : {
    marginLeft: '10px',
    marginRight: '10px'
  })
}));
